import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "@isolutions/branding/assets/css/theme.min.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
